import { FeatureFlagDeclarations } from '../feature-flag-declarations';
import { useFeatureFlag } from './use-feature-flag';

export const useEnableShippyExternalSupport = (): boolean => useFeatureFlag(FeatureFlagDeclarations.enableShippyExternalSupport);
